<template>
  <v-container>
    <h1>Opciones de administración técnica</h1>
    <template v-if="!erudaEstaHabilitado">
      <v-btn @click="mostrarEruda">Habilitar DevTools</v-btn>
    </template>
    <template v-else>
      <v-btn @click="inhabilitarEruda">Deshabilitar DevTools</v-btn>
    </template>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  computed: {
    ...mapState(["erudaEstaHabilitado"]),
  },
  methods: {
    ...mapActions(["mostrarEruda", "inhabilitarEruda"]),
  },
};
</script>
